import { z } from 'zod';
import { IdZ, NameZ, TsZ } from './common';

/** Roles are owner | member (R10). There is one crew per deployment and no crews table. */
export const ROLES = ['owner', 'member'] as const;
export const RoleZ = z.enum(ROLES);
export type Role = z.infer<typeof RoleZ>;

export const MemberZ = z.object({
  id: IdZ,
  playerId: IdZ.nullable(),
  role: RoleZ,
  displayName: NameZ,
  createdAt: TsZ,
  disabledAt: TsZ.nullable(),
});
export type Member = z.infer<typeof MemberZ>;

export const MemberPatchZ = z
  .object({
    role: RoleZ,
    disabled: z.boolean(),
  })
  .partial();
